<template>
  <div class="container">
    <div class="field mb-2" v-if="!customPaymentChosen">
      <div class="is-flex is-flex-wrap-wrap">
        <b-field v-for="payment in payments" :key="payment.id" class="ml-1 mr-1 payment-card">
          <!-- Clickable card container -->
          <div 
            @click="handlePaymentClick(payment)" 
            class="clickable-card" 
            :class="{ 'is-disabled': !payment.validExpiration }"
          >
            <FieldsetBox>
              <template #header>
                <div class="payment-card-header">
                  <span class="textOnly">
                    <img width="35" :src="cardLogos[payment.brand]" />
                  </span>
                </div>
              </template>
              <template #content>
                <div class="columns is-mobile">
                  <div class="column is-1">
                    <b-radio 
                      v-model="internalSelectedPayment" 
                      :name="payment.displayName" 
                      :native-value="payment"
                      class="pt-1" 
                      :disabled="!payment.validExpiration"
                    ></b-radio>
                  </div>
                  <div class="column is-11 has-text-left">
                    <div class="has-text-weight-bold payment-card-name">
                      {{ formattedDisplayNames[payment.id] }}
                    </div>
                    <div class="has-text-grey">Ending in {{ payment.last4 }}</div>
                    <div 
                      class="is-size-7" 
                      :class="{ 
                        'has-text-grey-light': payment.validExpiration, 
                        'has-text-danger': !payment.validExpiration 
                      }"
                    >
                      Expires {{ payment.expirationMonth }}/{{ payment.expirationYear }} 
                      <span 
                        class="has-text-grey" 
                        v-if="showUpdateCardOption(payment)"
                      >
                        | <u>Update Card</u>
                      </span>
                    </div>
                  </div>
                </div>
              </template>
            </FieldsetBox>
          </div>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import UpdateCardModal from "../CreditCardEntry/UpdateCardModal.vue";
import FieldsetBox from "../UI/FieldsetBox";

export default {
  name: "PaymentMethodCardGrid",
  components: {
    FieldsetBox
  },
  props: {
    payments: {
      type: Array,
      required: true
    },
    customPaymentChosen: {
      type: Boolean,
      default: false
    },
    selectedPayment: {
      type: Object,
      default: null
    },
    
  },
  data() {
    return {
      internalSelectedPayment: this.selectedPayment || null
    };
  },
  watch: {
    selectedPayment: {
      immediate: true,  // Ensure initial sync
      handler(newPayment) {
        this.internalSelectedPayment = newPayment;
      }
    }
  },
  computed: {
    formattedDisplayNames() {
      return this.payments.reduce((acc, payment) => {
        acc[payment.id] = payment.recordType === "Corporate Ghost Card" 
          ? "Corporate Ghost Card" 
          : payment.displayName;
        return acc;
      }, {});
    },
    cardLogos() {
      return this.payments.reduce((acc, payment) => {
        acc[payment.brand] = payment.brand 
          ? `/images/${payment.brand.toLowerCase()}.png` 
          : "/images/cc.png";
        return acc;
      }, {});
    }
  },
  methods: {
    handlePaymentClick(payment) {
      if (!payment.validExpiration) {
        if (payment.recordType !== "Corporate Ghost Card") {
          return this.openUpdateCardModal(payment);
        }
        return; // No action for Corporate Ghost Card with invalid expiration
      }

      this.selectPayment(payment);
    },
    selectPayment(payment) {
      this.internalSelectedPayment = payment;
      this.$emit("paymentSelected", [payment]); // Emit as an array
    },
    openUpdateCardModal(card) {
      this.$buefy.modal.open({
        parent: this,
        component: UpdateCardModal,
        hasModalCard: true,
        trapFocus: true,
        props: {
          card: card
        }
      });
    },
    showUpdateCardOption(payment) {
      return !payment.validExpiration && payment.recordType !== "Corporate Ghost Card";
    }
  }
};
</script>

<style scoped>
.payment-card-header {
  height: 35px;
}

/* Truncate card name to 2 lines */
.payment-card-name {
  height: calc(var(--line-height) * 2em);
  line-height: var(--line-height);
  --line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.clickable-card {
  cursor: pointer;
}

.clickable-card.is-disabled {
  background: whitesmoke;
  cursor: not-allowed;
}

@media screen and (max-width: 601px) {
  .payment-card {
    width: calc(100% - 0.5rem);
  }
}

@media screen and (min-width: 602px) and (max-width: 768px) {
  .payment-card {
    width: calc(50% - 0.5rem);
  }
}

@media screen and (min-width: 769px) and (max-width: 1215px) {
  .payment-card {
    width: calc(50% - 0.5rem);
  }
}

@media screen and (min-width: 1216px) {
  .payment-card {
    width: calc(33% - 0.5rem);
  }
}
</style>
